export default function scrollToTarget() {
    $('body').on('click keydown', '.scroll-to-target', function (e) {
        e.preventDefault();
        const target = $(e.currentTarget.hash);
        if (target.length) {
            $('html, body').animate({
                scrollTop: $(target).offset().top
            }, 300, function () {
                return window.history.pushState(null, null, e.currentTarget.hash);
            });
        }
    })
}
